import { FunctionComponent, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Option } from "space-monad";
import styled from "styled-components";
import { Icon } from "../../../components/icons";
import { CenteredFlex, columnFlex, Flex } from "../../../components/layout";
import { StepperContext } from "../../../components/stepper/context";
import { colours } from "../../../styles/colours";
import { size } from "../../../styles/media";
import { FormPrimaryButton, FormWidget } from "./components";
import { ConfigContext } from "./config-context";

const StyledWidget = styled(FormWidget)`
  flex-grow: 1;
  display: flex;
`;

const MainIcon = styled(Icon)`
  height: 8em;
  width: 8em;
  margin: 2em 0;
`;

interface IResultPageProps {
  error: Option<Error>;
}

const Wrapper = styled(Flex)`
  ${columnFlex};
  ${CenteredFlex};
  max-width: 100%;
  flex-grow: 1;
`;

const Title = styled.h1`
  @media (max-width: ${size.tablet - 1}px) {
    margin-top: 0;
  }
`;

const ResultPage: FunctionComponent<IResultPageProps> = ({ error }) => {
  const {
    state: { userExists },
    config,
  } = useContext(ConfigContext);

  const { t, i18n } = useTranslation("token-onboarding");
  const { back } = useContext(StepperContext);
  const currentLanguage = i18n.language.replaceAll("-", "_");
  return (
    <StyledWidget>
      <Wrapper>
        {error.fold(
          () => (
            <>
              <Title>{t("success", { ns: "common" })}</Title>
              <MainIcon type="veryGoodCheck" />
              {config.configuration?.submitMessage ? (<p>{config.configuration?.submitMessage?.[currentLanguage]}</p>) : (
                <>
                  <p>{t("we-have-successfully-received-your-application")}</p>
                  {userExists ? (
                    <>
                      <p>{t("kindly-login-to-sekuritance-portal")}</p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: t("for-further-assistance"),
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: t("kindly-be-informed-that"),
                        }}
                      />
                      {config.configuration.merchantConfig.createUserProfile ? (
                        <>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: t("kindly-verify-and-setup"),
                            }}
                          />

                          <p
                            dangerouslySetInnerHTML={{
                              __html: t("for-further-assistance-kindly"),
                            }}
                          />
                        </>
                      ) : null}
                    </>
                  )}
                </>
              )}
            </>
          ),
          (err) => (
            <>
              <Title>{t("error", { ns: "common" })}</Title>
              <MainIcon type="close" colour1={colours.redFailed} />
              <p>{err.message}</p>
              <p>
                <FormPrimaryButton onClick={() => back.next()}>
                  {t("back", { ns: "stepper" })}
                </FormPrimaryButton>
              </p>
            </>
          )
        )}
      </Wrapper>
    </StyledWidget>
  );
};

export default ResultPage;
